import { Box, Button, Chip, MenuItem, TextField, Typography, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import { useEffect, useState, useMemo } from "react";
import ContentHeader from "../mui/ContentHeader";
import { DataGrid, useGridApiRef } from "@mui/x-data-grid";
import { useHistory } from "react-router-dom";
import CustomFooter from "../mui/CustomFooter";
import { useDispatch, useSelector } from "react-redux";
import {  getAutoJiraTickets} from "../../actions";
import { isMobile } from 'react-device-detect';
import {useTranslation} from "react-i18next";
import { useParams } from "react-router-dom";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { generateUniqueId } from '../../helper/helper';
import { JiraTicket } from './jiraTicket';
import hasJiraIcon from "../../images/hasjira.svg";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Modal from "../mui/Modal";

const AutoJiraList = () => {
    const { alertSettingId } = useParams(); // Get settingid from the URL
    console.log(alertSettingId);
    const dispatch = useDispatch();
    const [closeFilter, setCloseFilter] = useState(false);
    const apiRef = useGridApiRef();
    const [rowPerPage, setRowPerPage] = useState(10);
    const [page, setPage] = useState(1);
    let history = useHistory();
    const alerts = useSelector(state => state.reportReducer.alerts);
    const autojiratickets = useSelector(state => state.reportReducer.autojiratickets);
    const statuses = useSelector(state => state.reportReducer.alertStatuses);
    const [selectedStatus, setSelectedStatus] = useState([]);
    const [filterStatus, setFilterStatus] = useState([]);
    const [fullTextSearch, setFullTextSearch] = useState('');
    const [openJiraModal, setOpenJiraModal] = useState('');
    const [testcaseData, setTestcaseData] = useState('');
    const {t} = useTranslation();

    const handlePageChange = (event, value) => {
        setPage(value)
    }

    const loadJiraTicket = (params) => {
        console.log(params);
        setTestcaseData(params?.row);

        if(!params.ignore) {
            createJiraTicket();
        }
    };
        
    const createJiraTicket = ()=> {
        setOpenJiraModal(generateUniqueId());
    }       
    const closeJiraModal = async (saved)=> {
        setOpenJiraModal('');

        if(saved) {
            await loadJiraTicket({
                ignore:true,
            })()
        }
    }

    const columns = [
        { field: "id", headerName: "ID", width: "90", disableColumnMenu: true, hide: true },
        {
            field: "alertsettingId",
            headerName: t("ALERT SETTING ID"),
            width: 200,
            disableColumnMenu: true,
            renderCell: params => (
                <div>{params.row.alertSettingId}</div>

            )

        },
        {
            field: "testcaseId",
            headerName: t("TEST CASE ID"),
            width: 200,
            disableColumnMenu: true,
            renderCell: params => (
                <div>{params.row.testcaseId}</div>

            )

        },
        {
            field: "jiraTicket",
            headerName: t("JIRA TICKET"),
            flex: 1,
            disableColumnMenu: true,
            renderCell: (params) => (
                params?.row?.jiraTicket ? (
                    <div
                        onClick={(event) => {
                            event.stopPropagation(); 
                            loadJiraTicket(params); // Call the function
                        }}
                        className="jira-ticket-link"
                        style={{ display: "inline-flex", alignItems: "center", cursor: "pointer" }}
                    >
                        <img
                            src={hasJiraIcon}
                            style={{ width: "20px", marginBottom: "-4px", marginRight: "5px" }}
                            alt="Jira Icon"
                        />
                        <span className="jira-ticket-id">{params?.row?.jiraTicket}</span>
                    </div>
                ) : (
                    <div>{params?.row?.jiraTicket}</div>
                )
            )
        },
        {
            field: "runid",
            headerName: t("RUN ID's"),
            flex: 1,
            disableColumnMenu: true,
            renderCell: params => (
                <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}> {/* Wrap items into multiple columns */}
                {params.row.runIds.split(',').reduce((acc, runId, index) => {
                    const columnIndex = Math.floor(index / 2); // Group every 2 items into a column
                    if (!acc[columnIndex]) acc[columnIndex] = []; // Initialize the column if it doesn't exist
                    acc[columnIndex].push(runId.trim());
                    return acc;
                }, []).map((column, colIndex) => (
                    <div key={colIndex} style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                        {column.map((runId, index) => (
                            <div
                                key={index}
                                onClick={() => history.push(`/report/run/${runId}`)}
                                style={{
                                    cursor: "pointer",
                                    padding: "8px 12px",
                                    border: "1px solid #ddd",
                                    borderRadius: "4px", 
                                    backgroundColor: "#f9f9f9",
                                    transition: "background-color 0.3s ease",
                                }}
                                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#e6f7ff")} 
                                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#f9f9f9")} 
                            >
                                <span style={{ fontSize: "14px", fontWeight: "500", color: "#0073e6" }}>
                                    {runId}
                                </span>
                            </div>
                        ))}
                    </div>
                ))}
            </div>
            )
        },
        // {
        //     field: "ation",
        //     headerName: t("ACTION"),
        //     flex: 1,
        //     disableColumnMenu: true,

        // },
    ];

    const rows = useMemo(() => {
        if (!autojiratickets) {
            return []; // Return an empty array if no data or alertSettingId changes
        }
            const tickets = Array.isArray(autojiratickets)
            ? autojiratickets 
            : autojiratickets
            ? [autojiratickets]
            : [];
    
        return tickets
            .filter(d => d?.runIds?.toString().includes(fullTextSearch)) 
            .map(item => ({
                ...item,
                id: item.id, 
                alertSettingId: item.alertSettingId,
                jiraTicket: item.jiraTicket,
                runid: item.runIds,
                testcaseId:item.testcaseId
            }));
    }, [autojiratickets, fullTextSearch]);

    const setSearchText = (input) => {
        setFullTextSearch(input);
    }

    useEffect(() => {
        
        setTestcaseData(''); // Clear testcase data if necessary

        // Fetch data when alertSettingId changes
        const fetchData = async () => {
            try {
                const response = await getAutoJiraTickets(alertSettingId)(dispatch); 
            } catch (error) {
                console.error("Error fetching Auto Jira Tickets:", error);
            }
        };
        if (alertSettingId) {
            fetchData();
        }
    }, [alertSettingId, dispatch]);


    return (
        <div style={isMobile ? { paddingBottom: '65px', paddingLeft: '24px', paddingRight: '24px', paddingTop: '0' } : { position: "absolute", top: "0px", left: "130px", width: `calc(100% - 200px)` }}>
            <ContentHeader title={t("AutoJiraList")} />
            <Box textAlign='left'
                sx={{
                    minWidth: isMobile ? "100%" : "500px",
                    borderColor: 'lightgrey',
                    borderRadius: '5px',
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    backgroundColor: '#1F9997',
                    marginBottom: '5px',
                    verticalAlign: 'middle'
                }}
            >
                <Typography type="body2" className="edit-title">
                    {t("Auto Jira Ticket List")}
                </Typography>

            </Box>
            <Box sx={{ mt: 3 }}>
           
            </Box>
            <Box sx={{ mt: 2, height: "550px", width: '100%' }}>
                {isMobile ? rows.map((item, index) => (
                    <Accordion key={`row_${item.id}`} className={`row_${index % 2}`} elevation={0}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <div className="db w-full">
                                <Typography className="underscore pointer w-full inline-block semi-bold" variant="caption"
                                ><span >{item.alertSettingId}</span></Typography>
                                <Typography className="w-full inline-block semi-bold" variant="caption">{item.testcaseId}</Typography>
                                <Typography className="w-full inline-block semi-bold" variant="caption"><span>{item.jiraTicket}</span></Typography>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <div className="db w-full">
                                <Typography className="w-full inline-block" variant="caption">{t("Run ID's")}: {item.runIds}</Typography>
                            </div>
                        </AccordionDetails>
                    </Accordion>
                )) : (
                    <DataGrid rows={rows} columns={columns}
                        apiRef={apiRef}
                        rowsPerPageOptions={[10, 20, 50, 100]}
                        pageSize={rowPerPage}
                        page={page - 1}
                        sortingOrder={['desc', 'asc']}
                        initialState={{
                            sorting: {
                                sortModel: [{ field: 'alertTime', sort: 'desc' }],
                            },
                        }}
                        components={{
                            Footer: () => CustomFooter(page, handlePageChange, autojiratickets?.totalElements || 0, rowPerPage, setRowPerPage, setPage)
                        }}
                        getCellClassName={(params) => {
                            if (params.field === "jiraTicket") {
                                return 'underscore pointer'
                            }

                        }}

                    />
                )}

            </Box>
            <Modal
                    isOpen={openJiraModal}
                    className={'full-width'}
                    title={testcaseData?.jiraTicket ? t("Modify Jira Ticket"):t("Create a Jira Ticket")}
                    body={<JiraTicket  testResultDetails={testcaseData} project={[]}  cancel={closeJiraModal} channel="" isReportSection={false}  isAutoJiraTicket={true} />}
                />
        </div>
    )

}

export default AutoJiraList;
